var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 588,
    zoomAndPan: "magnify",
    viewBox: "0 0 440.88 203.999996",
    height: 272,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3c6fcc8e0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46 173 L 49 173 L 49 175.082031 L 46 175.082031 Z M 46 173 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e23e8458c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 28.871094 L 327 28.871094 L 327 153 L 47 153 Z M 47 28.871094 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd8ef79da6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 319 46 L 395.207031 46 L 395.207031 80 L 319 80 Z M 319 46 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "34f5d2ff47"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#3c6fcc8e0d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fefffe",
      fillOpacity: 1
    },
    d: "M 48.113281 173.316406 C 47.800781 173.40625 47.714844 173.492188 47.363281 173.539062 C 47.097656 173.582031 46.832031 173.582031 46.566406 173.667969 C 46.082031 173.847656 45.773438 174.464844 46.214844 174.859375 C 46.566406 175.167969 47.363281 175.125 47.714844 174.816406 C 48.113281 174.464844 48.113281 174.023438 48.113281 173.316406 Z M 48.113281 173.316406 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#3e23e8458c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#003a5d",
      fillOpacity: 1
    },
    d: "M 293.089844 78.828125 C 297.632812 60.75 298.382812 42.320312 322.871094 45.539062 L 326.492188 29.664062 C 288.984375 25.121094 277.160156 39.9375 271.027344 69.921875 Z M 47.980469 150.699219 L 73.703125 40.863281 C 74.851562 35.21875 80.675781 30.941406 87.691406 30.941406 L 100.488281 30.941406 L 88.75 81.074219 C 97.355469 69.964844 127.003906 60.175781 140.640625 73.449219 C 151.316406 83.941406 144.921875 104.664062 141.300781 120.363281 L 134.066406 150.699219 L 109.886719 150.699219 L 120.167969 106.914062 C 122.945312 94.4375 123.785156 81.253906 107.503906 83.148438 C 101.941406 83.984375 96.824219 86.632812 93.03125 90.777344 C 83.765625 99.816406 81.027344 115.203125 77.058594 130.722656 L 74.453125 141.878906 C 73.351562 147.039062 68.761719 150.742188 63.511719 150.742188 Z M 323.359375 93.996094 C 307.5625 92.1875 287.441406 81.824219 260.878906 72.875 C 219.09375 58.722656 203.339844 70.273438 203.339844 70.273438 L 199.414062 87.074219 C 201.53125 85.351562 204.003906 84.117188 206.648438 83.457031 C 218.785156 80.679688 225.710938 89.675781 225.710938 99.59375 C 225.84375 118.15625 209.648438 137.953125 191.558594 137.777344 C 172.761719 137.601562 179.46875 118.289062 182.515625 105.414062 L 200.074219 30.941406 L 187.367188 30.941406 C 180.394531 30.941406 174.570312 35.265625 173.425781 40.863281 L 158.113281 106.648438 C 156.304688 114.1875 153.566406 124.152344 154.320312 132.839844 C 155.597656 146.730469 169.144531 151.84375 181.765625 152.59375 C 203.472656 153.960938 222.003906 146.816406 233.960938 134.515625 C 245.964844 122.214844 253.507812 101.800781 248.082031 83.367188 C 254.4375 84.292969 260.65625 85.835938 266.703125 87.953125 L 251.964844 150.699219 L 267.496094 150.699219 C 272.746094 150.652344 277.25 147.039062 278.394531 141.878906 L 289.558594 93.863281 C 312.8125 98.492188 323.359375 93.996094 323.359375 93.996094 Z M 323.359375 93.996094 "
  })), /*#__PURE__*/React.createElement("g", {
    clipRule: "nonzero",
    clipPath: "url(#bd8ef79da6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#90d3d0",
      fillOpacity: 1
    },
    d: "M 392.5 55.988281 C 390.425781 63.925781 388.042969 65.90625 383.457031 67.9375 C 366.378906 75.433594 347.890625 79.355469 329.183594 79.355469 C 325.917969 79.355469 322.652344 79.222656 319.386719 79.003906 C 347.757812 76.667969 381.777344 55.941406 395.015625 46.066406 Z M 392.5 55.988281 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#00b0ba",
      fillOpacity: 1
    },
    d: "M 382.308594 78.960938 C 359.453125 85.265625 319.917969 87.117188 295.296875 79.621094 C 331.875 94.304688 353.496094 93.773438 362.054688 93.332031 C 362.054688 93.332031 371.585938 93.332031 376.882812 86.367188 Z M 382.308594 78.960938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo6.7116c97216e4ca39bd877198c8669ff0.svg";
export { ForwardRef as ReactComponent };